export default __webpack_public_path__ + "static/media/36I-102696_-15658_0.8f24787c.jpg";